import { useTimeToEnd } from "../../modules/user/hooks/use-time-to-end";
import React from "react";

import './style.scss';
import { useIsConferenceOver } from "../../modules/game/hooks/use-is-conference-over";
import { useUserModuleState } from "../../modules/user";

type Props = {

}

const Clock: React.FunctionComponent<Props> = () => {

    const time = useTimeToEnd();
    const isConferenceOver = useIsConferenceOver();
    const {gameEnded} = useUserModuleState();

    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return (
        <>
            {time > 0 && !isConferenceOver && !gameEnded && <div className="clock">
                {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </div>}
        </>
    )
}

export default Clock;
